import { useContext, useState, createContext } from 'react';

export const FieldsContext = createContext({
  menuIsOpen: false,
});

export const FieldsContextProvider = ({ children }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  return (
    <FieldsContext.Provider value={{ menuIsOpen, setMenuIsOpen }}>
      {children}
    </FieldsContext.Provider>
  );
};

export const WithFieldContext = ({ children }) => {
  const context = useContext(FieldsContext);
  return children(context);
};
